import { Composition } from "remotion";
import {
  calcSlideshowMetadata,
  SlideshowComposition,
} from "./slideshow/SlideshowComposition";

import { FC } from "react";

export const RemotionRoot: FC = () => {
  return (
    <>
      <Composition
        id="Slideshow"
        component={SlideshowComposition}
        defaultProps={{
          imageUrls: [
            "https://picsum.photos/id/237/1500/1500",
            "https://samplelib.com/lib/preview/mp4/sample-15s.mp4",
            "https://picsum.photos/id/19/1500/1500",
          ],
          speechUrl:
            "http://localhost:9000/media/5affe101-b721-45f8-b9d8-7fd183fcd666/assets/rock-music-6211.mp3",
        }}
        durationInFrames={60}
        fps={30}
        width={1080}
        height={1920}
        calculateMetadata={calcSlideshowMetadata}
      />
    </>
  );
};
